import { apiRequest } from "@/lib/api";

export type PublicReview = {
  id: number;
  rating: number;
  comment: string;
  customer_display_name: string;
  is_verified: boolean;
  created_at: string;
};

export type PublicOrderReviewStatus = {
  eligible: boolean;
  review: PublicReview | null;
};

export async function getPublicOrderReview(
  token: string,
): Promise<PublicOrderReviewStatus> {
  return apiRequest<PublicOrderReviewStatus>(
    `/reviews/public/orders/${encodeURIComponent(token)}/`,
    {
      method: "GET",
    },
  );
}

export async function createPublicOrderReview(
  token: string,
  data: {
    rating: number;
    comment: string;
  },
): Promise<PublicReview> {
  return apiRequest<PublicReview>(
    `/reviews/public/orders/${encodeURIComponent(token)}/`,
    {
      method: "POST",
      body: JSON.stringify(data),
    },
  );
}


export type PublicCompanyReviewsResponse = {
  rating_average: number | null;
  rating_count: number;
  results: PublicReview[];
};

export async function getPublicCompanyReviews(
  slug: string,
): Promise<PublicCompanyReviewsResponse> {
  return apiRequest<PublicCompanyReviewsResponse>(
    `/reviews/public/companies/${encodeURIComponent(slug)}/`,
  );
}
